import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import ticketsService from '../services/ticketsService';
import { ticketsKeys } from '../queryKeys';

// Bloqueos de correo entrante (reglas "asunto/remitente contiene" que el backend
// aplica al ingerir el buzon de soporte). Cambian poco -> staleTime de 5 min,
// cacheado por sede. Las mutaciones invalidan la lista de la sede.

export const useBloqueos = (headquarter) =>
  useQuery({
    queryKey: ticketsKeys.bloqueos(headquarter),
    queryFn: async () => {
      const data = await ticketsService.listarBloqueos({ headquarter });
      return Array.isArray(data) ? data : [];
    },
    enabled: Boolean(headquarter),
    staleTime: 5 * 60 * 1000,
  });

// Correos que no crearon ticket por una regla (los últimos 200). Se refresca más a menudo.
export const useDescartados = (headquarter) =>
  useQuery({
    queryKey: ticketsKeys.descartados(headquarter),
    queryFn: async () => {
      const data = await ticketsService.listarDescartados({ headquarter });
      return Array.isArray(data) ? data : [];
    },
    enabled: Boolean(headquarter),
    staleTime: 60 * 1000,
  });

export const useCrearBloqueo = (headquarter) => {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (body) => ticketsService.crearBloqueo({ headquarter, ...body }),
    onSuccess: () => qc.invalidateQueries({ queryKey: ticketsKeys.bloqueos(headquarter) }),
  });
};

export const useEliminarBloqueo = (headquarter) => {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (id) => ticketsService.eliminarBloqueo({ headquarter, id }),
    onSuccess: () => qc.invalidateQueries({ queryKey: ticketsKeys.bloqueos(headquarter) }),
  });
};
